import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  USER_STORAGE,
  ROLE_USER,
  isAdmin,
  BRANCH_STORAGE,
} from "constants/index";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import { GitFork, Menu as MenuIcon, Trophy } from "lucide-react";
import {
  Settings,
  ChartCandlestick,
  CircleDollarSign,
  Users,
  Gauge,
  ClipboardCheck,
  Calendar,
  Dumbbell,
} from "lucide-react";
import { GetPropsMenu } from "./menu-custom";
import { getById } from "services/user/user-service";

const { Sider } = Layout;
const LOGO = require("images/login/logo-unique-branco.png");

const MenuApp = () => {
  const navigate = useNavigate();
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [collapsed, setCollapsed] = useState(false);
  const customMenu = GetPropsMenu(location.pathname);
  const [branchType, setBranchType] = useState(getTypeBranch());

  const [collapsedIcon, setCollapsedIcon] = useState({
    dash: null,
    financial: null,
    financialAdm: null,
    setting: null,
  });

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null && roleRedux == "") {
      const { role } = JSON.parse(localStorageItem);
      setRoleRedux(role);
    }
  }, []);

  useEffect(() => {
    let resizeTimeout = null;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const isSmall = window.innerWidth <= 1350;

        setCollapsed((prev) => {
          if (prev !== isSmall) return isSmall;
          return prev;
        });

        setCollapsedIcon({
          dash: isSmall ? (
            <ChartCandlestick size={20} style={{ marginLeft: "20px" }} />
          ) : null,
          financial: isSmall ? (
            <Settings size={20} style={{ marginLeft: "20px" }} />
          ) : null,
          setting: isSmall ? (
            <Settings size={20} style={{ marginLeft: "20px" }} />
          ) : null,
          financialAdm: isSmall ? (
            <CircleDollarSign size={20} style={{ marginLeft: "20px" }} />
          ) : null,
        });
      }, 150);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // estado inicial

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedType = getTypeBranch();
      setBranchType(updatedType);
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const currentType = getTypeBranch();
      setBranchType((prev) => (prev !== currentType ? currentType : prev));
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  function isBoot() {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { isBoot } = JSON.parse(localStorageItem);

      return isBoot == "true";
    } else {
      return false;
    }
  }

  function getTypeBranch() {
    const localStorageItemBranch = localStorage.getItem(BRANCH_STORAGE);
    if (localStorageItemBranch != null) {
      const { type } = JSON.parse(localStorageItemBranch);
      return type;
    } else {
      return "ESPORTIVO";
    }
  }

  function getItem(label, key, icon, children, type, router) {
    return {
      key,
      icon,
      children,
      label,
      type,
      onClick: () => {
        if (router) navigate(router);
      },
    };
  }
  const itemsAdm = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
      getItem(
        "Avaliações",
        "reviews",
        <ClipboardCheck size={15} />,
        null,
        null,
        "/app/client/reviews"
      ),

      getItem(
        "Planificação",
        "planning",
        <Calendar size={15} />,
        null,
        null,
        "/app/client/planning"
      ),
      getItem(
        "Controle de Cargas",
        "control",
        <Dumbbell size={15} />,
        null,
        null,
        "/app/client/load-control"
      ),
      getItem(
        "Classificação",
        "ranking",
        <Trophy size={15} />,
        null,
        null,
        "/app/client/ranking"
      ),
      getItem(
        "Treinos",
        "trainning",
        <Dumbbell size={15} />,
        null,
        null,
        "/app/client/trainning"
      ),
    ]),
    getItem("Cadastros", "sub2", collapsedIcon.financial, [
      getItem(
        "Usuários",
        "users",
        <Users size={15} />,
        null,
        null,
        "/app/client/users"
      ),
      ...(isAdmin()
        ? [
            getItem(
              "Unidades",
              "branches",
              <GitFork size={15} />,
              null,
              null,
              "/app/client/branches"
            ),
          ]
        : []),
    ]),
  ];

  const itemsUser = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
      getItem(
        "Avaliações",
        "reviews",
        <ClipboardCheck size={15} />,
        null,
        null,
        "/app/client/reviews"
      ),

      getItem(
        "Planificação",
        "planning",
        <Calendar size={15} />,
        null,
        null,
        "/app/client/planning"
      ),
      getItem(
        "Controle de Cargas",
        "control",
        <Dumbbell size={15} />,
        null,
        null,
        "/app/client/load-control"
      ),
      getItem(
        "Classificação",
        "7ranking",
        <Trophy size={15} />,
        null,
        null,
        "/app/client/ranking"
      ),
    ]),
  ];
  const itemsUserBoot = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),

      getItem(
        "Controle de Cargas",
        "control",
        <Dumbbell size={15} />,
        null,
        null,
        "/app/client/load-control"
      ),
      getItem(
        "Classificação",
        "ranking",
        <Trophy size={15} />,
        null,
        null,
        "/app/client/ranking"
      ),
    ]),
  ];

  const itemsAdmAqua = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
      getItem(
        "Avaliações",
        "reviews",
        <ClipboardCheck size={15} />,
        null,
        null,
        "/app/client/reviews"
      ),
      getItem(
        "Treinos",
        "trainning",
        <Dumbbell size={15} />,
        null,
        null,
        "/app/client/trainning"
      ),
    ]),
    getItem("Cadastros", "sub2", collapsedIcon.financial, [
      getItem(
        "Usuários",
        "users",
        <Users size={15} />,
        null,
        null,
        "/app/client/users"
      ),
      ...(isAdmin()
        ? [
            getItem(
              "Unidades",
              "branches",
              <GitFork size={15} />,
              null,
              null,
              "/app/client/branches"
            ),
          ]
        : []),
    ]),
  ];

  const itemsUserAqua = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
    ]),
  ];
  const itemsUserAquaBoot = [
    getItem("Academia", "sub1", collapsedIcon.dash, [
      getItem(
        "Painel Gerencial",
        "managerial",
        <Gauge size={15} />,
        null,
        null,
        "/app/client/managerial"
      ),
      getItem(
        "Avaliações",
        "reviews",
        <ClipboardCheck size={15} />,
        null,
        null,
        "/app/client/reviews"
      ),
      
    ]),
  ];
  const getMenuItems = () => {
    if (branchType === "AQUATICO") {
      return roleRedux === ROLE_USER
        ? isBoot()
          ? itemsUserAquaBoot
          : itemsUserAqua
        : itemsAdmAqua;
    }
    return roleRedux === ROLE_USER
      ? isBoot()
        ? itemsUserBoot
        : itemsUser
      : itemsAdm;
  };
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    if (!collapsed == true) {
      setCollapsedIcon({
        dash: <ChartCandlestick size={20} style={{ marginLeft: "20px" }} />,
        financial: <Settings size={20} style={{ marginLeft: "20px" }} />,
        setting: <Settings size={20} style={{ marginLeft: "20px" }} />,
        financialAdm: (
          <CircleDollarSign size={20} style={{ marginLeft: "20px" }} />
        ),
      });
    } else {
      setCollapsedIcon({
        dash: null,
        financial: null,
        setting: null,
        financialAdm: null,
      });
    }
  };
  if (outerWidth < 501) {
    return (
      <Menu
        mode="horizontal"
        theme="dark"
        defaultSelectedKeys={[customMenu.defaultSelectedKeys]}
        items={getMenuItems()}
      />
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={() => toggleCollapsed()}
      className="container-sider"
      id="siderMenu"
      width={"15%"}
      trackStyle={{ backgroundColor: "#12475c" }}
    >
      <div className="top-menu">
        <div
          onClick={toggleCollapsed}
          style={{
            marginBottom: 16,
            cursor: "pointer",
            color: "#ffffff",
            textAlign: "end",
            paddingRight: "15px",
          }}
        >
          {collapsed ? <MenuIcon size={20} /> : <MenuIcon size={20} />}
        </div>
        {!collapsed && <img className="logo-login" src={LOGO} alt="Logo" />}
      </div>

      <div className="body-menu">
        <Menu
          key={branchType}
          mode="inline"
          theme="dark"
          defaultOpenKeys={["sub1", "sub2"]}
          defaultSelectedKeys={[customMenu.defaultSelectedKeys]}
          selectedKeys={[customMenu.defaultSelectedKeys]}
          items={getMenuItems()}
        />
      </div>
    </Sider>
  );
};

export default MenuApp;
